export default class Tipfy {
  constructor(t) {
    document.addEventListener('mouseover', (e) => {
      ;(this.tag = e.target),
        document.querySelectorAll(t).forEach((t) => {
          const e = t.dataset.tipfy || t.title
          ;(t.dataset.tipfy = e),
            t.title &&
              (t.setAttribute('aria-label', t.title),
              t.removeAttribute('title'))
        }),
        this.remove(),
        this.tag.hasAttribute('data-tipfy') &&
          (this.build(),
          this.tag.addEventListener('mouseout', (t) => this.remove()))
    })
  }
  build() {
    const t = this.tag.dataset.tipfy
    let e
    try {
      e = this.tag.hasAttribute('data-tipfy-text')
        ? t
        : document.querySelector(t).outerHTML
    } catch (i) {
      e = t
    }
    ;(e = e
      .replace(/<script/g, '&lt;script')
      .replace(/<\/script/g, '&lt;/script')),
      document.body.insertAdjacentHTML(
        'beforeend',
        `<div class="tipfy" role="tooltip">${e}</div>`
      ),
      this.tag.hasAttribute('data-tipfy-class') &&
        document
          .querySelector('.tipfy')
          .classList.add(this.tag.dataset.tipfyClass),
      this.side()
  }
  side() {
    const t = document.querySelector('.tipfy'),
      e = this.tag.getBoundingClientRect(),
      i = window.scrollY,
      s = window.scrollX,
      l = this.tag.dataset.tipfySide
    if (l) {
      ;({
        left: () =>
          t.setAttribute(
            'style',
            `left: ${e.x - t.clientWidth + s}px;top: ${
              e.y + (e.height - t.clientHeight) / 2 + i
            }px;`
          ),
        right: () =>
          t.setAttribute(
            'style',
            `left: ${e.x + e.width + s}px;top: ${
              e.y + (e.height - t.clientHeight) / 2 + i
            }px;`
          ),
        top: () =>
          t.setAttribute(
            'style',
            `left: ${e.x + (e.width - t.clientWidth) / 2 + s}px;top: ${
              e.y - t.clientHeight + i
            }px;`
          ),
        bottom: () =>
          t.setAttribute(
            'style',
            `left: ${e.x + (e.width - t.clientWidth) / 2 + s}px;top: ${
              e.y + e.height + i
            }px;`
          ),
      }[l](),
        t.classList.add(`tipfy--side-${l}`))
    } else {
      const l = e.x < window.outerWidth / 2,
        o = e.y < window.outerHeight / 2
      t.classList.add(`tipfy--${l ? 'left' : 'right'}`),
        t.classList.add(`tipfy--${o ? 'top' : 'bottom'}`),
        (t.style.left = (l ? e.x : e.x + e.width - t.clientWidth) + s + 'px'),
        (t.style.top = (o ? e.y + e.height : e.y - t.clientHeight) + i + 'px')
    }
  }
  remove() {
    try {
      document.querySelector('.tipfy').remove()
    } catch (t) {}
  }
}
